import React from "react";
import {useNavigate} from "react-router-dom";
import {useMsal} from "@azure/msal-react";
import {Menu, MenuItem, Typography} from "@mui/material";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";


const AccountPopperComponent = (props) => {
  const {anchorEl, openAccountPopper, handleCloseMenu} = props;

  const {instance} = useMsal();
  const navigate = useNavigate();


  const handleLogout = async () => {
    try {
      await instance.logoutPopup();
      handleCloseMenu();
      navigate("/");

    } catch (error) {
      console.error("logout error xxxx", error);
    }
  }

  const handleNavigateActivityLogs = (e) => {
    navigate("/activity-logs");
    handleCloseMenu(); 
  }


  return (
    <Menu sx={{top: "35px"}}
      id="simple-menu"
      anchorEl={anchorEl}
      open={openAccountPopper}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      keepMounted
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      onClose={handleCloseMenu}
      onClick={handleCloseMenu}
    >
      <MenuItem sx={{paddingRight: "25px"}} onClick={(e) => handleNavigateActivityLogs(e)}>
      {/* onClick={() => navigate("/activity-logs")}  */}
        <ArticleOutlinedIcon sx={{color: "#5959D8"}} />

        <Typography sx={{ml: "5px", fontSize: 14}}> 
          Activity Logs
        </Typography>
      </MenuItem>

      <MenuItem onClick={handleLogout} sx={{paddingRight: "25px"}}>
        <ExitToAppOutlinedIcon sx={{color: "#5959D8"}} />

        <Typography sx={{ml: "5px", fontSize: 14}}> 
          Log Out
        </Typography>
      </MenuItem>
    </Menu>
  )
}

export default AccountPopperComponent